export default __webpack_public_path__ + "static/media/img1.4b562244.JPG";